<template>
	<div>
		<s-crud
			title="Control de Movimientos de Envases (Tránsito y Salidas)"
			:config="config"
			:filter="filter"
			height="calc(100vh - 300px)"
			add
			edit
			sortable
			searchInput
			btnsearch
			@addEvent="onAddMovement()"
			@EditEvent="onEditMovement($event)"
			@save="save($event)"
			ref="gridContainerMovement"
		>
			<!-- FORMULARIO DE REGISTRO / EDICIÓN (SALIDA A CAMPO) -->
			<template v-slot="props">
				<v-container fluid class="pa-2" v-if="props && props.item">
					<!-- SECCIÓN 1: FECHAS Y TIEMPOS DE TRÁNSITO -->
					<v-card flat class="cm-section-card cm-tone-blue mb-3">
						<div class="cm-section-header">
							<div class="cm-section-icon">
								<v-icon size="18" color="#1a5cff">mdi-calendar-clock</v-icon>
							</div>
							<div>
								<div class="cm-section-title">Fechas y Tiempo en Tránsito</div>
								<div class="cm-section-subtitle">Tiempos de salida y campaña activa</div>
							</div>
							<v-spacer></v-spacer>
							<div class="cm-section-number">01</div>
						</div>
						<div class="cm-section-body">
							<v-row justify="start">
								<v-col cols="12" md="4" class="s-col-form pb-0">
									<s-date
										label="Fecha de Salida *"
										v-model="props.item.CmvDepartureDate"
										@change="onDepartureDateChange($event, props.item)"
									></s-date>
								</v-col>
								<v-col cols="12" md="4" class="s-col-form pb-0">
									<s-date
										label="Fecha de Ingreso / Retorno (Se registra al retornar)"
										v-model="props.item.CmvEntryDate"
										disabled
										clearable
									></s-date>
								</v-col>
								<v-col cols="12" md="4" class="s-col-form pb-0">
									<v-text-field
										label="Días en Tránsito"
										:value="computeTransitDays(props.item)"
										readonly
										dense
										outlined
										hide-details="auto"
										class="s-custom-input cm-computed-field"
									></v-text-field>
								</v-col>
							</v-row>
							<v-row justify="start" class="mt-2">
								<v-col cols="12" md="3" class="s-col-form pb-0">
									<s-text label="Campaña" v-model="props.item.CmvCampaign"></s-text>
								</v-col>
								<v-col cols="12" md="3" class="s-col-form pb-0">
									<s-number label="Semana" v-model="props.item.CmvWeek"></s-number>
								</v-col>
								<v-col cols="12" md="3" class="s-col-form pb-0">
									<s-number label="Mes" v-model="props.item.CmvMonth"></s-number>
								</v-col>
								<v-col cols="12" md="3" class="s-col-form pb-0">
									<s-number label="Año" v-model="props.item.CmvYear"></s-number>
								</v-col>
							</v-row>
						</div>
					</v-card>

					<!-- SECCIÓN 2: TRANSPORTE Y GUÍA -->
					<v-card flat class="cm-section-card cm-tone-teal mb-3">
						<div class="cm-section-header">
							<div class="cm-section-icon">
								<v-icon size="18" color="#0f9d8a">mdi-truck-cargo-container</v-icon>
							</div>
							<div>
								<div class="cm-section-title">Información del Vehículo y Documento</div>
								<div class="cm-section-subtitle">Placas, empresa transportista y guía de remisión</div>
							</div>
							<v-spacer></v-spacer>
							<div class="cm-section-number">02</div>
						</div>
						<div class="cm-section-body">
							<v-row justify="start">
								<v-col cols="12" md="3" class="s-col-form pb-0">
									<s-select-vehicle
										label="Placa Principal *"
										v-model="props.item.CmvLicensePlateID"
										:text="vehiclePlateText(props.item)"
										return-object
										clearable
										no-default
										@returnObject="onVehicleSelect($event, props.item)"
									></s-select-vehicle>
								</v-col>
								<v-col cols="12" md="3" class="s-col-form pb-0">
									<s-text label="Otras Placas / Carreta" v-model="props.item.CmvSecondaryLicensePlate"></s-text>
								</v-col>
								<v-col cols="12" md="3" class="s-col-form pb-0">
									<s-select-carriers
										label="Empresa Transportista"
										v-model="props.item.CmvCarrier"
										:text="props.item.CmvCarrier"
										item-value="SpcCompanyName"
										clearable
									></s-select-carriers>
								</v-col>
								<v-col cols="12" md="3" class="s-col-form pb-0">
									<s-select-driver
										label="Chofer Responsable"
										v-model="props.item.CmvDriver"
										:text="props.item.CmvDriver"
										clearable
										full
									></s-select-driver>
								</v-col>
								<v-col cols="12" md="3" class="s-col-form pb-0 mt-2">
									<s-text label="N° Guía de Remisión" v-model="props.item.CmvReferralGuide"></s-text>
								</v-col>
								<v-col cols="12" md="3" class="s-col-form pb-0 mt-2">
									<s-select-agricultural
										label="Zona / Fundo Cosecha"
										v-model="props.item.CmvLocation"
										:text="farmText(props.item)"
										clearable
										full
										@change="onFarmSelect($event, props.item)"
									></s-select-agricultural>
								</v-col>
								<v-col cols="12" md="3" class="s-col-form pb-0 mt-2">
									<s-select-foreman
										label="Capataz"
										v-model="props.item.CmvForemanID"
										:text="foremanText(props.item)"
										clearable
										full
										@input="onForemanSelect($event, props.item)"
									></s-select-foreman>
								</v-col>
							</v-row>
						</div>
					</v-card>

					<!-- SECCIÓN 3: ESPECIFICACIONES DE ENVASES Y MATERIALES A DESPACHAR (MULTILÍNEA) -->
					<v-card flat class="cm-section-card cm-tone-violet mb-3">
						<div class="cm-section-header">
							<div class="cm-section-icon">
								<v-icon size="18" color="#7a5cf0">mdi-package-variant-closed</v-icon>
							</div>
							<div>
								<div class="cm-section-title">Envases y Materiales a Despachar</div>
								<div class="cm-section-subtitle">Seleccione la planta de origen y detalle los tipos de envases que traslada el vehículo</div>
							</div>
							<v-spacer></v-spacer>
							<div class="cm-section-number">03</div>
						</div>
						<div class="cm-section-body" v-if="ensureItemDetails(props.item)">
							<v-row justify="start" class="mb-2">
								<v-col cols="12" md="6" class="s-col-form pb-0">
									<s-select-definition
										:def="1730"
										label="Planta / Ubicación de Origen *"
										v-model="props.item.CinLocationID"
										add
										clearable
										searchable
										@change="onPlantChange(props.item)"
									></s-select-definition>
								</v-col>
								<v-col cols="12" md="6" class="s-col-form pb-0 d-flex align-center justify-end">
									<v-btn
										small
										color="primary"
										class="text-capitalize elevation-1 font-weight-bold"
										@click="addDetailRow(props.item)"
									>
										<v-icon left small>mdi-plus-box</v-icon>
										Agregar Envase / Material
									</v-btn>
								</v-col>
							</v-row>

							<!-- TABLA INTERACTIVA MULTILÍNEA -->
							<v-simple-table dense class="cm-multiline-table elevation-1 rounded mb-2">
								<template v-slot:default>
									<thead>
										<tr style="background: #f8fafc;">
											<th style="width: 35px;" class="text-center">#</th>
											<th style="min-width: 220px;">Envase / SKU *</th>
											<th style="min-width: 130px;">Tipo</th>
											<th style="min-width: 120px;">Color</th>
											<th style="min-width: 120px;">Estado</th>
											<th style="min-width: 130px;">Fruto / Cultivo</th>
											<th style="min-width: 110px;" class="text-center">Stock Planta</th>
											<th style="min-width: 120px;" class="text-center">Cant. Sale *</th>
											<th style="width: 45px;"></th>
										</tr>
									</thead>
									<tbody>
										<tr v-for="(row, idx) in props.item.Details" :key="idx">
											<td class="text-center font-weight-bold grey--text">{{ idx + 1 }}</td>
											<td>
												<v-autocomplete
													:items="containerMasterList"
													item-text="CmtDescription"
													item-value="CmtID"
													placeholder="Seleccionar SKU *"
													v-model="row.CmtID"
													dense
													outlined
													hide-details="auto"
													class="s-custom-input my-1"
													@change="onDetailSkuSelect(row, props.item)"
													@focus="loadContainerMasterList"
												></v-autocomplete>
											</td>
											<td>
												<s-select-definition
													:def="1728"
													label="Tipo"
													v-model="row.CmdContainerType"
													clearable
													searchable
													hide-details="auto"
													class="my-1"
												></s-select-definition>
											</td>
											<td>
												<s-select-definition
													:def="1729"
													label="Color"
													v-model="row.CmdContainerColor"
													clearable
													searchable
													hide-details="auto"
													class="my-1"
												></s-select-definition>
											</td>
											<td>
												<s-select-definition
													:def="1735"
													label="Estado"
													v-model="row.CmdStatus"
													clearable
													searchable
													hide-details="auto"
													class="my-1"
													@change="loadRowStock(row, props.item)"
												></s-select-definition>
											</td>
											<td>
												<s-select-definition
													:def="1173"
													label="Cultivo"
													v-model="row.CmdFruit"
													clearable
													searchable
													hide-details="auto"
													class="my-1"
												></s-select-definition>
											</td>
											<td class="text-center">
												<v-chip
													x-small
													label
													:color="getRowStockColor(row)"
													class="font-weight-bold"
												>
													{{ row.availableStock != null ? row.availableStock + ' u.' : (props.item.CinLocationID ? 'Consultando...' : 'Elija planta') }}
												</v-chip>
											</td>
											<td>
												<v-text-field
													type="number"
													v-model.number="row.CmdQuantityOut"
													dense
													outlined
													hide-details="auto"
													min="0"
													class="s-custom-input my-1 font-weight-bold text-center"
													@input="onRowQuantityChange(props.item)"
													:error="isRowInsufficientStock(row)"
												></v-text-field>
											</td>
											<td class="text-center">
												<v-btn
													icon
													x-small
													color="error"
													title="Eliminar fila"
													:disabled="(props.item.Details || []).length <= 1"
													@click="removeDetailRow(props.item, idx)"
												>
													<v-icon small>mdi-delete-outline</v-icon>
												</v-btn>
											</td>
										</tr>
									</tbody>
								</template>
							</v-simple-table>

							<!-- ALERTA DE STOCK INSUFICIENTE -->
							<v-alert
								v-if="hasAnyInsufficientStock(props.item)"
								dense
								outlined
								type="error"
								class="caption font-weight-bold mb-2"
							>
								<v-icon small color="error" class="mr-1">mdi-alert-octagon</v-icon>
								Stock insuficiente en una o más líneas seleccionadas: La cantidad de salida supera la disponibilidad física en planta.
							</v-alert>

							<!-- BARRA DE RESUMEN TOTALIZADORA -->
							<div class="d-flex justify-space-between align-center flex-wrap pa-3 mt-1" style="background: #f8fafc; border: 1px solid #e2e8f0; border-radius: 6px;">
								<div class="caption grey--text text--darken-3">
									Variedad de Envases: <strong class="indigo--text font-weight-bold">{{ (props.item.Details || []).length }} SKU(s)</strong>
								</div>
								<div class="subtitle-2 font-weight-bold grey--text text--darken-4">
									Total Salida a Despachar: <strong class="green--text text--darken-3" style="font-size: 11pt;">{{ computeTotalQuantityOut(props.item) }} unidades</strong>
								</div>
							</div>
						</div>
					</v-card>

					<!-- SECCIÓN 4: RESUMEN GLOBAL DE CANTIDADES Y SALDOS -->
					<v-card flat class="cm-section-card cm-tone-green mb-3">
						<div class="cm-section-header">
							<div class="cm-section-icon">
								<v-icon size="18" color="#2e9e5b">mdi-calculator-variant</v-icon>
							</div>
							<div>
								<div class="cm-section-title">Resumen Global de Cantidades</div>
								<div class="cm-section-subtitle">Consolidado general del viaje (Salidas, Ingresos y Deuda Pendiente)</div>
							</div>
							<v-spacer></v-spacer>
							<div class="cm-section-number">04</div>
						</div>
						<div class="cm-section-body">
							<v-row justify="start">
								<v-col cols="12" md="4" class="s-col-form pb-0">
									<v-text-field
										label="Total Cantidad Sale *"
										:value="computeTotalQuantityOut(props.item)"
										readonly
										dense
										outlined
										hide-details="auto"
										class="s-custom-input cm-computed-field font-weight-bold"
									></v-text-field>
								</v-col>
								<v-col cols="12" md="4" class="s-col-form pb-0">
									<v-text-field
										label="Total Ingreso / Retorno (se registra al retornar)"
										:value="props.item.CmvQuantityIn || 0"
										readonly
										dense
										outlined
										hide-details="auto"
										class="s-custom-input cm-computed-field"
									></v-text-field>
								</v-col>
								<v-col cols="12" md="4" class="s-col-form pb-0">
									<v-text-field
										label="Debe Global (Saldo Pendiente)"
										:value="computeTotalQuantityOwed(props.item)"
										readonly
										dense
										outlined
										hide-details="auto"
										class="s-custom-input cm-computed-field cm-owed-field font-weight-bold"
									></v-text-field>
								</v-col>
							</v-row>
						</div>
					</v-card>

					<!-- SECCIÓN 5: PROVEEDOR, UBICACIÓN, CIUDAD Y RESPONSABLES -->
					<v-card flat class="cm-section-card cm-tone-amber mb-3">
						<div class="cm-section-header">
							<div class="cm-section-icon">
								<v-icon size="18" color="#e08a00">mdi-map-marker-account</v-icon>
							</div>
							<div>
								<div class="cm-section-title">Proveedor, Ubicación y Responsables</div>
								<div class="cm-section-subtitle">Proveedor, destino y responsables del movimiento</div>
							</div>
							<v-spacer></v-spacer>
							<div class="cm-section-number">05</div>
						</div>
						<div class="cm-section-body">
							<v-row justify="start">
								<!-- CONTROL DE ASIGNACIÓN DE RESPONSABLE / DEUDA -->
								<v-col cols="12" class="s-col-form pb-2">
									<div class="d-flex align-center flex-wrap" style="gap: 10px;">
										<span class="caption font-weight-bold grey--text text--darken-3">
											Responsable / Deudor de Envases:
										</span>
										<v-btn-toggle
											:value="getDebtorType(props.item)"
											mandatory
											dense
											class="cm-debtor-toggle"
											@change="onDebtorTypeChange($event, props.item)"
										>
											<v-btn
												x-small
												value="SUPPLIER"
												:disabled="filter.DebtType === 'CARRIER'"
												:class="getDebtorType(props.item) === 'SUPPLIER' ? 'blue darken-2 white--text font-weight-bold' : ''"
											>
												<v-icon left x-small>mdi-domain</v-icon>
												Proveedor (Cosechero)
											</v-btn>
											<v-btn
												x-small
												value="CARRIER"
												:disabled="filter.DebtType === 'SUPPLIER'"
												:class="getDebtorType(props.item) === 'CARRIER' ? 'teal darken-1 white--text font-weight-bold' : ''"
											>
												<v-icon left x-small>mdi-truck</v-icon>
												Transportista
											</v-btn>
										</v-btn-toggle>
										<span v-if="filter.DebtType === 'CARRIER'" class="caption teal--text text--darken-2 font-weight-medium">
											<v-icon x-small color="teal darken-2" class="mr-1">mdi-lock</v-icon>
											Bloqueado por filtro de búsqueda: Deuda asignada a Transportista
										</span>
										<span v-else-if="isCarrierDebtTarget(props.item)" class="caption teal--text text--darken-2 font-weight-medium">
											<v-icon x-small color="teal darken-2" class="mr-1">mdi-check-circle</v-icon>
											Deuda asignada a Transportista (Proveedor inhabilitado)
										</span>
									</div>
								</v-col>

								<v-col cols="12" md="4" class="s-col-form pb-0">
									<s-provider
										label="Proveedor"
										v-model="props.item.CmvSupplier"
										:text="props.item.CmvSupplierName || props.item.CmvSupplier"
										:disabled="isCarrierDebtTarget(props.item)"
										clearable
									></s-provider>
									<div v-if="isCarrierDebtTarget(props.item)" class="caption teal--text text--darken-3 mt-1 font-weight-medium">
										<v-icon x-small color="teal darken-3">mdi-information-outline</v-icon>
										Deuda de Transportista (campo proveedor bloqueado)
									</div>
								</v-col>
								<v-col cols="12" md="4" class="s-col-form pb-0">
									<s-select-worker label="Supervisor Responsable" id="WkrName" v-model="props.item.CmvSupervisor" :text="props.item.CmvSupervisor" clearable></s-select-worker>
								</v-col>
								<v-col cols="12" md="4" class="s-col-form pb-0">
									<s-select-definition
										:def="1732"
										label="Tipo Movimiento"
										v-model="props.item.CmvType"
										add
										clearable
										searchable
									></s-select-definition>
								</v-col>
								<v-col cols="12" md="4" class="s-col-form pb-0">
									<s-select-definition
										:def="1731"
										label="Ciudad / Destino"
										v-model="props.item.CmvCity"
										add
										clearable
										searchable
									></s-select-definition>
								</v-col>
								<v-col cols="12" md="8" class="s-col-form pb-0">
									<s-text label="Observación" v-model="props.item.CmvObservation"></s-text>
								</v-col>
							</v-row>
						</div>
					</v-card>
				</v-container>
			</template>

			<!-- FILTROS DE LA TABLA AGRUPADOS Y CON MEJOR UX/UI -->
			<template v-slot:filter>
				<v-card flat class="cm-filter-card mb-2 pa-3">
					<!-- BARRA SUPERIOR: TÍTULO, ACCESO RÁPIDO POR TIPO DE DEUDA Y BOTONES -->
					<div class="d-flex align-center justify-space-between flex-wrap mb-2 pb-2" style="border-bottom: 1px solid #e2e8f0;">
						<div class="d-flex align-center flex-wrap">
							<v-icon small color="primary" class="mr-1">mdi-filter-variant</v-icon>
							<span class="subtitle-2 font-weight-bold grey--text text--darken-4 mr-3">
								Filtros de Búsqueda
							</span>

							<!-- ACCESO RÁPIDO: TIPO DE DEUDA -->
							<div class="d-flex align-center flex-wrap mr-2">
								<span class="caption grey--text text--darken-1 mr-2 font-weight-medium">Tipo de Deuda:</span>
								<v-chip
									x-small
									class="mr-1 font-weight-bold"
									:color="filter.DebtType === null ? 'primary' : 'grey lighten-4'"
									:text-color="filter.DebtType === null ? 'white' : 'grey darken-3'"
									@click="setQuickDebtType(null)"
								>
									Todas
								</v-chip>
								<v-chip
									x-small
									class="mr-1 font-weight-bold"
									:color="filter.DebtType === 'CARRIER' ? 'teal darken-1' : 'teal lighten-5'"
									:text-color="filter.DebtType === 'CARRIER' ? 'white' : 'teal darken-4'"
									@click="setQuickDebtType('CARRIER')"
								>
									<v-icon left x-small>mdi-truck</v-icon>
									Transportista
								</v-chip>
								<v-chip
									x-small
									class="mr-1 font-weight-bold"
									:color="filter.DebtType === 'SUPPLIER' ? 'blue darken-2' : 'blue lighten-5'"
									:text-color="filter.DebtType === 'SUPPLIER' ? 'white' : 'blue darken-4'"
									@click="setQuickDebtType('SUPPLIER')"
								>
									<v-icon left x-small>mdi-domain</v-icon>
									Proveedor
								</v-chip>
							</div>

							<v-chip x-small color="primary" outlined class="font-weight-bold ml-2" v-if="activeFiltersCount > 0">
								{{ activeFiltersCount }} filtro(s) activo(s)
							</v-chip>
						</div>

						<!-- BOTONES DE ACCIÓN DEL PANEL DE FILTROS -->
						<div class="d-flex align-center mt-1 mt-sm-0">
							<v-btn
								x-small
								outlined
								color="grey darken-2"
								class="text-capitalize font-weight-medium mr-2"
								@click="clearFilters"
							>
								<v-icon left x-small>mdi-filter-remove-outline</v-icon>
								Limpiar
							</v-btn>
							<v-btn
								icon
								x-small
								@click="filtersExpanded = !filtersExpanded"
								:title="filtersExpanded ? 'Plegar filtros' : 'Desplegar filtros'"
							>
								<v-icon small>{{ filtersExpanded ? 'mdi-chevron-up' : 'mdi-chevron-down' }}</v-icon>
							</v-btn>
						</div>
					</div>

					<!-- CUERPO DE FILTROS AGRUPADOS (3 GRUPOS EN GRID) -->
					<v-expand-transition>
						<div v-show="filtersExpanded">
							<v-row dense justify="start">
								<!-- GRUPO 1: RANGO DE FECHAS DE SALIDA -->
								<v-col cols="12" md="3" class="cm-filter-group pr-md-2">
									<div class="cm-group-label">
										<v-icon x-small color="grey darken-2" class="mr-1">mdi-calendar-range</v-icon>
										Rango de Salida
									</div>
									<v-row dense>
										<v-col cols="12" sm="6" class="s-col-form pb-0">
											<s-date label="Salida Desde" v-model="filter.StartDate" clearable></s-date>
										</v-col>
										<v-col cols="12" sm="6" class="s-col-form pb-0">
											<s-date label="Salida Hasta" v-model="filter.EndDate" clearable></s-date>
										</v-col>
									</v-row>
								</v-col>

								<!-- GRUPO 2: LOGÍSTICA Y TRANSPORTE -->
								<v-col cols="12" md="5" class="cm-filter-group px-md-2">
									<div class="cm-group-label">
										<v-icon x-small color="grey darken-2" class="mr-1">mdi-truck-outline</v-icon>
										Transporte y Responsable
									</div>
									<v-row dense>
										<v-col cols="12" sm="4" class="s-col-form pb-0">
											<s-text label="Placa" v-model="filter.LicensePlate"></s-text>
										</v-col>
										<v-col cols="12" sm="8" class="s-col-form pb-0">
											<s-select-carriers label="Empresa Transportista" v-model="filter.Carrier" item-value="SpcCompanyName" clearable></s-select-carriers>
										</v-col>
										<v-col cols="12" class="s-col-form pb-0 mt-1">
											<s-text
												label="Proveedor (RUC / Razón Social)"
												v-model="filter.Supplier"
												:disabled="filter.DebtType === 'CARRIER'"
											></s-text>
										</v-col>
									</v-row>
								</v-col>

								<!-- GRUPO 3: MATERIAL Y UBICACIÓN -->
								<v-col cols="12" md="4" class="cm-filter-group pl-md-2">
									<div class="cm-group-label">
										<v-icon x-small color="grey darken-2" class="mr-1">mdi-package-variant</v-icon>
										Material y Planta
									</div>
									<v-row dense>
										<v-col cols="12" sm="6" class="s-col-form pb-0">
											<v-autocomplete
												:items="containerMasterList"
												item-text="CmtDescription"
												item-value="CmtID"
												label="Envase / SKU"
												v-model="filter.CmtID"
												dense
												outlined
												hide-details="auto"
												class="s-custom-input"
												clearable
												@focus="loadContainerMasterList"
											></v-autocomplete>
										</v-col>
										<v-col cols="12" sm="6" class="s-col-form pb-0">
											<s-select-definition
												:def="1730"
												label="Planta Origen"
												v-model="filter.CinLocationID"
												clearable
												searchable
											></s-select-definition>
										</v-col>
									</v-row>
								</v-col>
							</v-row>
						</div>
					</v-expand-transition>
				</v-card>
			</template>

			<!-- SLOT PERSONALIZADO PARA COLUMNA DÍAS TRÁNSITO EN LA TABLA -->
			<template v-slot:item.CmvTransitDays="{ item }">
				<v-chip
					small
					label
					:color="getTransitColor(item)"
					class="white--text font-weight-bold"
				>
					<v-icon left small v-if="isMovementPending(item)">mdi-clock-outline</v-icon>
					<v-icon left small v-else>mdi-check-circle-outline</v-icon>
					{{ item.CmvTransitDays != null ? item.CmvTransitDays : 0 }} d
					<span v-if="isMovementFullyReturned(item)"> (Retornado)</span>
					<span v-else-if="isMovementPartiallyReturned(item)"> (Retorno Parcial)</span>
					<span v-else> (En Tránsito)</span>
				</v-chip>
			</template>

			<!-- SLOT DE ENVASE SKU CON SOPORTE MULTILÍNEA -->
			<template v-slot:item.CmtDescription="{ item }">
				<div v-if="item.DetailCount > 1">
					<v-tooltip bottom max-width="360">
						<template v-slot:activator="{ on, attrs }">
							<v-chip
								x-small
								color="indigo darken-1"
								dark
								class="font-weight-bold cursor-pointer elevation-1"
								v-bind="attrs"
								v-on="on"
								@click.stop="viewMovementDetails(item)"
							>
								<v-icon left x-small>mdi-layers-triple-outline</v-icon>
								{{ item.DetailCount }} tipos de envase
							</v-chip>
						</template>
						<div>
							<div class="caption font-weight-bold mb-1">Desglose de Envases Despachados:</div>
							<div class="caption" style="white-space: pre-wrap;">{{ item.DetailSummary || 'Haga clic para ver el detalle multilínea' }}</div>
						</div>
					</v-tooltip>
				</div>
				<div v-else class="text-truncate" style="max-width: 190px;" :title="item.CmtDescription">
					{{ item.CmtDescription || '-' }}
				</div>
			</template>

			<!-- FORMATO UNIFORME Y TRUNCADO PARA TEXTOS LARGOS -->
			<template v-slot:item.CmvCarrier="{ item }">
				<v-tooltip bottom v-if="item.CmvCarrier && item.CmvCarrier.length > 20" max-width="320">
					<template v-slot:activator="{ on, attrs }">
						<span v-bind="attrs" v-on="on" class="d-inline-block text-truncate" style="max-width: 170px;">
							{{ item.CmvCarrier }}
						</span>
					</template>
					<span>{{ item.CmvCarrier }}</span>
				</v-tooltip>
				<span v-else>{{ item.CmvCarrier || '-' }}</span>
			</template>

			<template v-slot:item.CmvLocationName="{ item }">
				<v-tooltip bottom v-if="item.CmvLocationName && item.CmvLocationName.length > 18" max-width="300">
					<template v-slot:activator="{ on, attrs }">
						<span v-bind="attrs" v-on="on" class="d-inline-block text-truncate" style="max-width: 150px;">
							{{ item.CmvLocationName }}
						</span>
					</template>
					<span>{{ item.CmvLocationName }}</span>
				</v-tooltip>
				<span v-else>{{ item.CmvLocationName || '-' }}</span>
			</template>

			<template v-slot:item.CmvSupplier="{ item }">
				<v-tooltip bottom v-if="(item.CmvSupplierName || item.CmvSupplier) && (item.CmvSupplierName || item.CmvSupplier).length > 18" max-width="320">
					<template v-slot:activator="{ on, attrs }">
						<span v-bind="attrs" v-on="on" class="d-inline-block text-truncate" style="max-width: 170px;">
							{{ item.CmvSupplierName || item.CmvSupplier }}
						</span>
					</template>
					<div>
						<div class="font-weight-bold">{{ item.CmvSupplierName || item.CmvSupplier }}</div>
						<div class="caption grey--text text--lighten-2" v-if="item.CmvSupplier && item.CmvSupplierName && item.CmvSupplier !== item.CmvSupplierName">
							Código / RUC: {{ item.CmvSupplier }}
						</div>
					</div>
				</v-tooltip>
				<span v-else>{{ item.CmvSupplierName || item.CmvSupplier || '-' }}</span>
			</template>

			<template v-slot:item.CmvQuantityOwed="{ item }">
				<span
					:class="Number(item.CmvQuantityOwed) > 0 ? 'warning--text text--darken-3 font-weight-bold' : 'teal--text text--darken-2 font-weight-medium'"
				>
					{{ item.CmvQuantityOwed != null ? item.CmvQuantityOwed : 0 }}
				</span>
			</template>

			<!-- SLOT DE TIPO DE MOVIMIENTO (FRESCOS / IQF / MAQUILA) -->
			<template v-slot:item.CmvTypeName="{ item }">
				<v-chip
					v-if="item.CmvTypeName"
					x-small
					label
					:color="item.CmvTypeName === 'IQF' ? 'blue lighten-5' : (item.CmvTypeName === 'FRESCOS' ? 'teal lighten-5' : (item.CmvTypeName === 'MAQUILA' ? 'purple lighten-5' : 'grey lighten-3'))"
					:class="item.CmvTypeName === 'IQF' ? 'blue--text text--darken-4 font-weight-bold' : (item.CmvTypeName === 'FRESCOS' ? 'teal--text text--darken-4 font-weight-bold' : (item.CmvTypeName === 'MAQUILA' ? 'purple--text text--darken-4 font-weight-bold' : 'grey--text text--darken-2 font-weight-bold'))"
				>
					{{ item.CmvTypeName }}
				</v-chip>
				<span v-else class="caption grey--text text--lighten-1">-</span>
			</template>

			<template v-slot:item.CmvLossQuantity="{ item }">
				<span
					:class="Number(item.CmvLossQuantity) > 0 ? 'red--text text--darken-2 font-weight-bold' : 'grey--text text--darken-1'"
				>
					{{ item.CmvLossQuantity != null ? item.CmvLossQuantity : 0 }}
				</span>
			</template>

			<!-- SLOT DE OBSERVACIÓN: PREVIENE QUE TEXTOS LARGOS ROMPAN LA ALTURA DE FILAS -->
			<template v-slot:item.CmvObservation="{ item }">
				<div v-if="item.CmvObservation" class="d-flex align-center text-no-wrap">
					<v-tooltip bottom max-width="420">
						<template v-slot:activator="{ on, attrs }">
							<span
								v-bind="attrs"
								v-on="on"
								class="d-inline-block text-truncate grey--text text--darken-3 caption cursor-pointer"
								style="max-width: 200px;"
								@click.stop="showFullObservation(item)"
							>
								{{ item.CmvObservation }}
							</span>
						</template>
						<span>{{ item.CmvObservation }}</span>
					</v-tooltip>
					<v-btn
						v-if="item.CmvObservation.length > 25"
						icon
						x-small
						class="ml-1 grey--text text--darken-1"
						title="Ver observación completa"
						@click.stop="showFullObservation(item)"
					>
						<v-icon x-small>mdi-text-box-search-outline</v-icon>
					</v-btn>
				</div>
				<span v-else class="caption grey--text text--lighten-1">-</span>
			</template>

			<!-- BOTÓN DE ACCIÓN RÁPIDA: REGISTRAR DEVOLUCIÓN Y EXPORTAR PDF -->
			<template v-slot:item.actions="{ item }">
				<!-- Mientras tenga saldo pendiente por devolver (CmvQuantityOwed > 0), el botón se mantiene activo -->
				<v-btn
					v-if="isMovementPending(item)"
					x-small
					:color="isMovementPartiallyReturned(item) ? 'indigo darken-1' : 'primary'"
					class="text-capitalize font-weight-bold elevation-0 mr-1 white--text"
					@click.stop="openReturnModal(item)"
				>
					<v-icon left x-small>mdi-package-down</v-icon>
					{{ isMovementPartiallyReturned(item) ? 'Registrar Saldo' : 'Registrar Retorno' }}
				</v-btn>
				<template v-else>
					<v-chip x-small color="success" outlined class="font-weight-bold mr-1">
						<v-icon left x-small>mdi-check-circle</v-icon>
						Retornado Completo
					</v-chip>
				</template>
				<v-btn
					x-small
					color="error"
					outlined
					class="text-capitalize font-weight-bold ml-1"
					@click.stop="openPdf(item)"
				>
					<v-icon left x-small>mdi-file-pdf-box</v-icon>
					PDF
				</v-btn>
			</template>
		</s-crud>

		<!-- MODAL FLOTANTE DE REGISTRO DE RETORNO / RECEPCIÓN DE ENVASES (MULTILÍNEA) -->
		<v-dialog v-model="returnDialog" max-width="920" persistent>
			<v-card class="rounded-lg">
				<v-card-title class="cm-tone-indigo pa-4 flex-nowrap">
					<v-icon color="#4f46e5" class="mr-2">mdi-truck-check</v-icon>
					<span class="text-h6 font-weight-bold text--primary">Registrar Retorno / Recepción de Envases</span>
					<v-spacer></v-spacer>
					<v-btn icon small @click="returnDialog = false">
						<v-icon>mdi-close</v-icon>
					</v-btn>
				</v-card-title>

				<v-card-text class="pa-4">
					<!-- Ficha resumen del viaje -->
					<v-alert colored-border border="left" color="indigo" class="pa-3 mb-3 bg-light-indigo">
						<div class="caption font-weight-bold text-uppercase grey--text text--darken-2">Resumen del Viaje de Salida</div>
						<div class="subtitle-2 font-weight-bold text--primary">
							Movimiento #{{ returnItem.CmvID }} | Guía: <strong>{{ returnItem.CmvReferralGuide || 'N/A' }}</strong>
						</div>
						<div class="caption grey--text text--darken-1 mt-1">
							Placa: <strong>{{ returnItem.CmvLicensePlate || 'N/A' }}</strong> | Transportista: <strong>{{ returnItem.CmvCarrier || 'N/A' }}</strong>
							<span v-if="returnItem.CmvSupplierName"> | Proveedor: <strong>{{ returnItem.CmvSupplierName }}</strong></span>
						</div>
						<div class="d-flex justify-space-between flex-wrap text-caption font-weight-medium mt-2 pt-2" style="border-top: 1px dashed #cbd5e1;">
							<span>Despacho Total: <strong class="indigo--text">{{ returnItem.CmvQuantityOut || 0 }} u.</strong></span>
							<span>Ya Devueltos Anteriormente: <strong class="teal--text text--darken-2">{{ previouslyReturnedCount }} u.</strong></span>
							<span>Saldo Pendiente Actual: <strong class="orange--text text--darken-3 font-weight-bold">{{ returnItem.CmvQuantityOwed || 0 }} u.</strong></span>
						</div>
					</v-alert>

					<div class="subtitle-2 font-weight-bold grey--text text--darken-3 mb-2">
						Datos del Retorno:
					</div>
					<v-row justify="start">
						<v-col cols="12" md="4" class="pb-0">
							<s-date
								label="Fecha de Ingreso / Retorno *"
								v-model="deliveryForm.CmvEntryDate"
							></s-date>
						</v-col>
						<v-col cols="12" md="4" class="pb-0">
							<s-select-definition
								:def="1730"
								label="Planta / Ubicación de Retorno *"
								v-model="deliveryForm.ReturnLocationID"
								clearable
								searchable
							></s-select-definition>
						</v-col>
						<v-col cols="12" md="4" class="pb-0">
							<s-text
								label="Guía de Retorno"
								v-model="deliveryForm.CmvReturnGuide"
								clearable
							></s-text>
						</v-col>
						<v-col cols="12" md="6" class="pb-0">
							<s-text
								label="Placa de Retorno *"
								v-model="deliveryForm.CmvReturnLicensePlate"
							></s-text>
						</v-col>
						<v-col cols="12" md="6" class="pb-0 d-flex align-center">
							<div class="caption grey--text text--darken-2">
								Placa de salida: <strong>{{ returnItem.CmvLicensePlate || 'N/A' }}</strong>
								<span v-if="returnItem.CmvSecondaryLicensePlate"> | Otras: {{ returnItem.CmvSecondaryLicensePlate }}</span>
							</div>
						</v-col>
						<v-col cols="12" class="pb-0">
							<s-textarea
								label="Observaciones de esta Entrega"
								v-model="deliveryForm.CmvObservation"
							></s-textarea>
						</v-col>
					</v-row>

					<v-alert
						v-if="returnPlateMismatch"
						colored-border
						border="left"
						color="orange"
						class="mt-2 mb-2"
					>
						<div class="caption font-weight-bold">
							<v-icon x-small color="orange darken-2">mdi-alert-circle</v-icon>
							La Placa de Retorno no coincide con la placa de salida. Registre el motivo en Observaciones para continuar.
						</div>
					</v-alert>

					<!-- TABLA DE RECEPCIÓN POR SKU -->
					<div class="subtitle-2 font-weight-bold grey--text text--darken-3 mt-3 mb-1">
						Detalle de Envases Recibidos en esta Entrega:
					</div>
					<v-simple-table dense class="cm-return-table elevation-1 rounded mb-2">
						<template v-slot:default>
							<thead>
								<tr style="background: #f1f5f9;">
									<th style="width: 30px;">#</th>
									<th>Envase / SKU</th>
									<th>Color</th>
									<th class="text-center">Salida</th>
									<th class="text-center">Debe</th>
									<th style="min-width: 110px;" class="text-center">Útiles (Buenas) *</th>
									<th style="min-width: 110px;" class="text-center">Mal Estado</th>
									<th style="min-width: 110px;" class="text-center">Rotas / Merma</th>
									<th class="text-center">Quedará</th>
								</tr>
							</thead>
							<tbody>
								<tr v-for="(row, idx) in returnDetailsList" :key="idx">
									<td class="text-center font-weight-bold grey--text">{{ idx + 1 }}</td>
									<td class="font-weight-medium">{{ row.CmtDescription || 'Sin SKU' }}</td>
									<td>{{ row.CmdContainerColorName || row.CmdContainerColor || '-' }}</td>
									<td class="text-center font-weight-bold">{{ row.CmdQuantityOut }}</td>
									<td class="text-center font-weight-bold orange--text text--darken-3">{{ row.CmdQuantityOwed }}</td>
									<td>
										<v-text-field
											dense
											outlined
											hide-details="auto"
											type="number"
											min="0"
											v-model.number="row.CmdQuantityIn"
											placeholder="0"
											class="s-custom-input my-1 text-center"
										></v-text-field>
									</td>
									<td>
										<v-text-field
											dense
											outlined
											hide-details="auto"
											type="number"
											min="0"
											v-model.number="row.CmdDefectiveQuantity"
											placeholder="0"
											class="s-custom-input my-1 text-center"
										></v-text-field>
									</td>
									<td>
										<v-text-field
											dense
											outlined
											hide-details="auto"
											type="number"
											min="0"
											v-model.number="row.CmdLossQuantity"
											placeholder="0"
											class="s-custom-input my-1 text-center"
										></v-text-field>
									</td>
									<td class="text-center font-weight-bold" :class="getRowProjectedOwed(row) > 0 ? 'orange--text text--darken-4' : 'green--text text--darken-2'">
										{{ getRowProjectedOwed(row) }}
									</td>
								</tr>
							</tbody>
						</template>
					</v-simple-table>

					<!-- BALANCE GLOBAL DEL RETORNO -->
					<v-card flat outlined class="pa-3 mt-2" style="background: #f8fafc; border: 1px solid #e2e8f0; border-radius: 8px;">
						<div class="caption font-weight-bold text-uppercase grey--text text--darken-2 mb-1">
							Balance de la Recepción Multilínea
						</div>
						<div class="d-flex justify-space-between flex-wrap text-caption font-weight-medium">
							<span>Saldo pendiente total: <strong class="orange--text text--darken-3">{{ returnItem.CmvQuantityOwed || 0 }} u.</strong></span>
							<span>Entrega en este viaje: <strong class="indigo--text font-weight-bold">{{ totalReturnBatch }} u.</strong> (Buenas: {{ totalReturnIn }}, Mal Estado: {{ totalReturnDefective }}, Mermas: {{ totalReturnLoss }})</span>
							<span>Quedará debiendo: <strong :class="totalProjectedRemainingOwed > 0 ? 'orange--text text--darken-4 font-weight-bold' : 'green--text text--darken-2 font-weight-bold'">{{ totalProjectedRemainingOwed }} u.</strong></span>
						</div>
						<div v-if="totalProjectedRemainingOwed === 0 && totalReturnBatch > 0" class="caption green--text text--darken-2 font-weight-bold mt-2">
							<v-icon x-small color="success">mdi-check-circle</v-icon>
							¡Con esta entrega todas las líneas quedarán 100% saldadas y el viaje pasará a Retornado Completo!
						</div>
					</v-card>
				</v-card-text>

				<v-card-actions class="pa-4 pt-0">
					<v-spacer></v-spacer>
					<v-btn text color="grey darken-1" class="text-capitalize" @click="returnDialog = false">
						Cancelar
					</v-btn>
					<v-btn color="primary" class="text-capitalize px-4" @click="confirmReturn">
						<v-icon left small>mdi-content-save-check</v-icon>
						Confirmar Recepción y Actualizar Stock
					</v-btn>
				</v-card-actions>
			</v-card>
		</v-dialog>

		<!-- MODAL FLOTANTE DE VISTA RÁPIDA DE DETALLE MULTILÍNEA -->
		<v-dialog v-model="viewDetailsDialog" max-width="680">
			<v-card class="rounded-lg">
				<v-card-title class="cm-tone-indigo pa-4 d-flex align-center flex-nowrap" style="background: #f8fafc; border-bottom: 1px solid #e2e8f0;">
					<v-icon color="#4f46e5" class="mr-2">mdi-layers-triple-outline</v-icon>
					<span class="text-subtitle-1 font-weight-bold grey--text text--darken-3">
						Desglose Multilínea de Envases &bull; Movimiento #{{ selectedMovementForDetails ? selectedMovementForDetails.CmvID : '' }}
					</span>
					<v-spacer></v-spacer>
					<v-btn icon small @click="viewDetailsDialog = false">
						<v-icon>mdi-close</v-icon>
					</v-btn>
				</v-card-title>
				<v-card-text class="pa-4">
					<div v-if="selectedMovementForDetails" class="caption mb-3 grey--text text--darken-2">
						Guía: <strong>{{ selectedMovementForDetails.CmvReferralGuide || 'N/A' }}</strong> &bull;
						Placa: <strong>{{ selectedMovementForDetails.CmvLicensePlate || 'N/A' }}</strong> &bull;
						Transportista: <strong>{{ selectedMovementForDetails.CmvCarrier || 'N/A' }}</strong>
					</div>
					<v-simple-table dense class="elevation-1 rounded">
						<thead>
							<tr style="background: #f1f5f9;">
								<th style="width: 35px;">#</th>
								<th>Envase / SKU</th>
								<th>Color</th>
								<th>Cultivo</th>
								<th class="text-right">Salida</th>
								<th class="text-right">Retornado</th>
								<th class="text-right">Mal Estado</th>
								<th class="text-right">Merma</th>
								<th class="text-right">Saldo Debe</th>
							</tr>
						</thead>
						<tbody>
							<tr v-for="(d, idx) in movementDetailsForView" :key="idx">
								<td class="text-center font-weight-bold grey--text">{{ idx + 1 }}</td>
								<td class="font-weight-medium">{{ d.CmtDescription || 'Sin SKU' }}</td>
								<td>{{ d.CmdContainerColorName || d.CmdContainerColor || '-' }}</td>
								<td>{{ d.CmdFruitName || d.CmdFruit || '-' }}</td>
								<td class="text-right font-weight-bold">{{ d.CmdQuantityOut }}</td>
								<td class="text-right teal--text text--darken-2 font-weight-bold">{{ d.CmdQuantityIn }}</td>
								<td class="text-right purple--text text--darken-2">{{ d.CmdDefectiveQuantity }}</td>
								<td class="text-right red--text text--darken-2">{{ d.CmdLossQuantity }}</td>
								<td class="text-right orange--text text--darken-3 font-weight-bold">{{ d.CmdQuantityOwed }}</td>
							</tr>
						</tbody>
					</v-simple-table>
				</v-card-text>
				<v-card-actions class="pa-4 pt-0">
					<v-spacer></v-spacer>
					<v-btn text color="primary" class="text-capitalize font-weight-bold" @click="viewDetailsDialog = false">
						Cerrar
					</v-btn>
				</v-card-actions>
			</v-card>
		</v-dialog>

		<!-- MODAL FLOTANTE DE VISTA PREVIA Y DESCARGA DE PDF -->
		<v-dialog v-if="dialogPdf" v-model="dialogPdf" fullscreen persistent>
			<pdf-container-movement :item="selectedMovementPdf" @close="dialogPdf = false"></pdf-container-movement>
		</v-dialog>

		<!-- MODAL FLOTANTE DE OBSERVACIÓN COMPLETA (INSPECCIÓN RÁPIDA) -->
		<v-dialog v-model="observationDialog" max-width="560">
			<v-card class="rounded-lg">
				<v-card-title class="cm-tone-blue pa-4 d-flex align-center flex-nowrap" style="background: #f8fafc; border-bottom: 1px solid #e2e8f0;">
					<v-icon color="primary" class="mr-2">mdi-text-box-search-outline</v-icon>
					<span class="text-subtitle-1 font-weight-bold grey--text text--darken-3">Detalle de la Observación</span>
					<v-spacer></v-spacer>
					<v-btn icon small @click="observationDialog = false">
						<v-icon>mdi-close</v-icon>
					</v-btn>
				</v-card-title>
				<v-card-text class="pa-4">
					<div v-if="selectedObservationItem" class="caption mb-3 grey--text text--darken-2">
						<strong>Movimiento #{{ selectedObservationItem.CmvID }}</strong> &bull;
						SKU: <strong>{{ selectedObservationItem.CmtDescription || 'N/A' }}</strong> &bull;
						Guía: <strong>{{ selectedObservationItem.CmvReferralGuide || 'N/A' }}</strong>
					</div>
					<v-card flat outlined class="pa-3" style="background: #ffffff; border: 1px solid #e2e8f0; border-radius: 6px;">
						<p class="body-2 grey--text text--darken-4 mb-0" style="white-space: pre-wrap; line-height: 1.5;">
							{{ selectedObservationItem ? selectedObservationItem.CmvObservation : '' }}
						</p>
					</v-card>
				</v-card-text>
				<v-card-actions class="pa-4 pt-0">
					<v-spacer></v-spacer>
					<v-btn text color="primary" class="text-capitalize font-weight-bold" @click="observationDialog = false">
						Cerrar
					</v-btn>
				</v-card-actions>
			</v-card>
		</v-dialog>
	</div>
</template>

<script>
	import moment from "moment";
	import _sContainerMovementService from "@/services/Logistics/ContainerMovementService.js";
	import _sContainerMasterService from "@/services/Logistics/ContainerMasterService.js";
	import _sContainerInventoryService from "@/services/Logistics/ContainerInventoryService.js";
	import _sHarvestScheduleService from "@/services/Technicalassistance/HarvestSchedule.js";
	import SSelectVehicle from "@/components/Utils/Vehicle/SSelectVehicle.vue";
	import SSelectCarriers from "@/components/Utils/SSelectCarriers.vue";
	import SProvider from "@/components/Utils/SProvider.vue";
	import SSelectDefinition from "@/components/Utils/SSelectDefinition.vue";
	import SSelectDriver from "@/components/HarvestSchedule/sSelectDriver.vue";
	import SSelectAgricultural from "@/components/HarvestSchedule/SSelectAgricultural.vue";
	import SSelectForeman from "@/components/HarvestSchedule/SSelectForeman.vue";
	import SSelectWorker from "@/components/Utils/Worker/sSelectWorker.vue";
	import PdfContainerMovement from "./PdfContainerMovement.vue";

	export default {
		name: "ContainerMovement",
		components: {
			SSelectVehicle,
			SSelectCarriers,
			SProvider,
			SSelectDefinition,
			SSelectDriver,
			SSelectAgricultural,
			SSelectForeman,
			SSelectWorker,
			PdfContainerMovement
		},
		data() {
			const currentDate = moment();
			return {
				filter: {
					StartDate: null,
					EndDate: null,
					Supplier: null,
					LicensePlate: null,
					Carrier: null,
					DebtType: null,
					CmtID: null,
					CinLocationID: null
				},
				debtTypeOptions: [
					{ text: "Todas las Deudas", value: null },
					{ text: "Deuda Transportista (Sin Prov.)", value: "CARRIER" },
					{ text: "Deuda Proveedor (Con Prov.)", value: "SUPPLIER" },
				],
				formDebtorType: null,
				filtersExpanded: true,
				observationDialog: false,
				selectedObservationItem: null,
				containerMasterList: [],
				farmsList: [],
				foremenList: [],
				stockInfo: null,
				returnDialog: false,
				returnItem: {},
				deliveryForm: {
					CmvEntryDate: null,
					ReturnLocationID: null,
					CmvReturnLicensePlate: "",
					CmvReturnGuide: "",
					CmvQuantityIn: "",
					CmvDefectiveQuantity: "",
					CmvLossQuantity: "",
					CmvStatus: "",
					CmvObservation: ""
				},
				viewDetailsDialog: false,
				selectedMovementForDetails: null,
				movementDetailsForView: [],
				loadingMovementDetails: false,
				returnDetailsList: [],
				loadingReturnDetails: false,
				dialogPdf: false,
				selectedMovementPdf: null,
				config: {
					service: _sContainerMovementService,
					model: {
						CmvID: "ID",
						CmvDepartureDate: currentDate.format("YYYY-MM-DD"),
						CmvEntryDate: null,
						CmvCampaign: currentDate.year().toString(),
						CmvWeek: currentDate.isoWeek(),
						CmvMonth: currentDate.month() + 1,
						CmvYear: currentDate.year(),
						ObjectCmvLicensePlate: "",
						CmvLicensePlate: null,
						CmvLicensePlateID: null,
						CmvSecondaryLicensePlate: "",
						CmvReturnLicensePlate: "",
						CmvReturnGuide: "",
						CmvCarrier: "",
						CmvDriver: "",
						CmvForeman: "",
						CmvForemanID: null,
						CmvReferralGuide: "",
						CmtID: null,
						CinLocationID: null,
						CmvContainerType: "",
						CmvContainerColor: "",
						CmvQuantityOut: 0,
						CmvQuantityIn: 0,
						CmvDefectiveQuantity: 0,
						CmvQuantityOwed: 0,
						CmvLocation: "",
						CmvSupplier: "",
						CmvSupervisor: "",
						CmvFruit: "",
						CmvType: "",
						CmvStatus: "",
						CmvCity: "",
						CmvLossQuantity: 0,
						CmvObservation: "",
						SecStatus: 1
					},
					headers: [
						{ text: "Acción", value: "actions", sortable: false, width: "240" },
						{ text: "ID", value: "CmvID" },
						{ text: "F. Salida", value: "CmvDepartureDate" },
						{ text: "F. Ingreso", value: "CmvEntryDate" },
						{ text: "Días Tránsito", value: "CmvTransitDays" },
						{ text: "Envase SKU", value: "CmtDescription", width: "180" },
						{ text: "Planta / Ubicación", value: "CinLocationName", width: "160" },
						{ text: "Campaña", value: "CmvCampaign" },
						// { text: "Semana", value: "CmvWeek" },
						// { text: "Mes", value: "CmvMonth" },
						// { text: "Año", value: "CmvYear" },
						{ text: "Placas", value: "CmvLicensePlate" },
						{ text: "Otras Placas", value: "CmvSecondaryLicensePlate" },
						{ text: "Placa Retorno", value: "CmvReturnLicensePlate" },
						{ text: "Transportista", value: "CmvCarrier" },
						{ text: "Chofer", value: "CmvDriver" },
						{ text: "Guía Salida", value: "CmvReferralGuide" },
						{ text: "Guía Retorno", value: "CmvReturnGuide" },
						{ text: "Envase", value: "CmvContainerTypeName" },
						{ text: "Color", value: "CmvContainerColorName" },
						{ text: "Cant. Sale", value: "CmvQuantityOut" },
						{ text: "Cant. Ingresa", value: "CmvQuantityIn" },
						{ text: "Mal Estado", value: "CmvDefectiveQuantity" },
						{ text: "Debe", value: "CmvQuantityOwed" },
						{ text: "Ubicación / Fundo", value: "CmvLocationName" },
						{ text: "Capataz", value: "CmvForeman", width: "150" },
						{ text: "Proveedor", value: "CmvSupplier" },
						{ text: "Supervisor Resp.", value: "CmvSupervisor" },
						{ text: "Fruto", value: "CmvFruitName" },
						{ text: "Tipo", value: "CmvTypeName" },
						{ text: "Estado", value: "CmvStatusName" },
						{ text: "Ciudad", value: "CmvCityName" },
						{ text: "Pérdidas", value: "CmvLossQuantity" },
						{ text: "Observación", value: "CmvObservation" }
					]
				}
			};
		},
		computed: {
			previouslyReturnedCount() {
				if (!this.returnItem) return 0;
				const inQty = parseFloat(this.returnItem.CmvQuantityIn) || 0;
				const defQty = parseFloat(this.returnItem.CmvDefectiveQuantity) || 0;
				const lossQty = parseFloat(this.returnItem.CmvLossQuantity) || 0;
				return inQty + defQty + lossQty;
			},
			currentDeliveryTotal() {
				if (!this.deliveryForm) return 0;
				const inQty = parseFloat(this.deliveryForm.CmvQuantityIn) || 0;
				const defQty = parseFloat(this.deliveryForm.CmvDefectiveQuantity) || 0;
				const lossQty = parseFloat(this.deliveryForm.CmvLossQuantity) || 0;
				return inQty + defQty + lossQty;
			},
			projectedRemainingOwed() {
				if (!this.returnItem) return 0;
				const owed = parseFloat(this.returnItem.CmvQuantityOwed) || 0;
				const rem = owed - this.currentDeliveryTotal;
				return rem >= 0 ? rem : 0;
			},
			totalReturnIn() {
				if (!this.returnDetailsList || !this.returnDetailsList.length) return 0;
				return this.returnDetailsList.reduce((acc, r) => acc + (parseFloat(r.CmdQuantityIn) || 0), 0);
			},
			totalReturnDefective() {
				if (!this.returnDetailsList || !this.returnDetailsList.length) return 0;
				return this.returnDetailsList.reduce((acc, r) => acc + (parseFloat(r.CmdDefectiveQuantity) || 0), 0);
			},
			totalReturnLoss() {
				if (!this.returnDetailsList || !this.returnDetailsList.length) return 0;
				return this.returnDetailsList.reduce((acc, r) => acc + (parseFloat(r.CmdLossQuantity) || 0), 0);
			},
			totalReturnBatch() {
				return this.totalReturnIn + this.totalReturnDefective + this.totalReturnLoss;
			},
			totalProjectedRemainingOwed() {
				if (!this.returnDetailsList || !this.returnDetailsList.length) return 0;
				return this.returnDetailsList.reduce((acc, r) => acc + this.getRowProjectedOwed(r), 0);
			},
			normalizedReturnPlate() {
				return String(this.deliveryForm.CmvReturnLicensePlate || "")
					.trim()
					.toUpperCase();
			},
			returnPlateMismatch() {
				if (!this.normalizedReturnPlate) return false;
				const origin = String(this.returnItem.CmvLicensePlate || "")
					.trim()
					.toUpperCase();
				const secondary = String(this.returnItem.CmvSecondaryLicensePlate || "")
					.trim()
					.toUpperCase();
				if (!origin && !secondary) return false;
				if (origin && this.normalizedReturnPlate === origin) return false;
				if (secondary && this.normalizedReturnPlate === secondary) return false;
				return true;
			},
			activeFiltersCount() {
				let count = 0;
				if (this.filter.StartDate) count++;
				if (this.filter.EndDate) count++;
				if (this.filter.Carrier && String(this.filter.Carrier).trim()) count++;
				if (this.filter.Supplier && String(this.filter.Supplier).trim()) count++;
				if (this.filter.LicensePlate && String(this.filter.LicensePlate).trim()) count++;
				if (this.filter.DebtType) count++;
				if (this.filter.CmtID) count++;
				if (this.filter.CinLocationID) count++;
				return count;
			}
		},
		mounted() {
			this.loadContainerMasterList();
			this.loadFarmsList();
			this.loadForemenList();
		},
		methods: {
			loadFarmsList() {
				if (this.farmsList && this.farmsList.length) return;
				_sHarvestScheduleService
					.listAgriculturalFarm(0, "", this.$fun.getUserID())
					.then((res) => {
						if (res && res.status === 200 && Array.isArray(res.data)) {
							this.farmsList = res.data;
						}
					})
					.catch(() => {});
			},
			loadForemenList() {
				if (this.foremenList && this.foremenList.length) return;
				_sHarvestScheduleService
					.listForeman(0, "", this.$fun.getUserID())
					.then((res) => {
						if (res && res.status === 200 && Array.isArray(res.data)) {
							this.foremenList = res.data;
						}
					})
					.catch(() => {});
			},
			vehiclePlateText(item) {
				if (!item) return "";
				if (item.CmvLicensePlate != null) return String(item.CmvLicensePlate);
				if (item.CmvLicensePlateID != null && typeof item.CmvLicensePlateID !== "object") return String(item.CmvLicensePlateID);
				return "";
			},
			farmText(item) {
				if (!item) return "";
				if (typeof item.CmvLocationName === "string" && item.CmvLocationName.trim()) return item.CmvLocationName;
				if (typeof item.CmvLocation === "string" && item.CmvLocation.trim()) {
					if (this.farmsList && this.farmsList.length) {
						const found = this.farmsList.find((f) => String(f.FagID) === String(item.CmvLocation));
						if (found && found.FagName) return found.FagName;
					}
					return item.CmvLocation;
				}
				if (typeof item.CmvLocation === "number") {
					if (this.farmsList && this.farmsList.length) {
						const found = this.farmsList.find((f) => Number(f.FagID) === item.CmvLocation);
						if (found && found.FagName) return found.FagName;
					}
					return String(item.CmvLocation);
				}
				if (item.CmvLocation && typeof item.CmvLocation === "object") {
					return String(item.CmvLocation.FagName || item.CmvLocation.fagName || item.CmvLocation.FagID || "");
				}
				return "";
			},
			foremanText(item) {
				if (!item) return "";
				if (typeof item.CmvForeman === "string" && item.CmvForeman.trim()) return item.CmvForeman;
				if (item.CmvForeman && typeof item.CmvForeman === "object") {
					return String(item.CmvForeman.Foreman || item.CmvForeman.foreman || "");
				}
				if (item.CmvForemanID && typeof item.CmvForemanID !== "object" && this.foremenList && this.foremenList.length) {
					const found = this.foremenList.find((f) => String(f.NtpID) === String(item.CmvForemanID));
					if (found && found.Foreman) return found.Foreman;
				}
				return "";
			},
			applyFilters() {
				const grid = this.$refs.gridContainerMovement;
				if (grid && typeof grid.searchBtn === "function") {
					grid.searchBtn();
				}
			},
			setQuickDebtType(val) {
				if (this.filter.DebtType === val) {
					this.filter.DebtType = null;
					this.formDebtorType = null;
				} else {
					this.filter.DebtType = val;
					if (val === "CARRIER") {
						this.filter.Supplier = null;
						this.formDebtorType = "CARRIER";
					} else if (val === "SUPPLIER") {
						this.formDebtorType = "SUPPLIER";
					} else {
						this.formDebtorType = null;
					}
				}
				this.applyFilters();
			},
			onAddMovement() {
				if (this.filter.DebtType === "CARRIER") {
					this.formDebtorType = "CARRIER";
				} else if (this.filter.DebtType === "SUPPLIER") {
					this.formDebtorType = "SUPPLIER";
				} else {
					this.formDebtorType = null;
				}
			},
			onEditMovement(selected) {
				const item = Array.isArray(selected) && selected.length ? selected[0] : selected;
				if (item) {
					if (this.filter.DebtType === "CARRIER") {
						this.formDebtorType = "CARRIER";
					} else if (this.filter.DebtType === "SUPPLIER") {
						this.formDebtorType = "SUPPLIER";
					} else if (item.CmvSupplier && String(item.CmvSupplier).trim() !== "") {
						this.formDebtorType = "SUPPLIER";
					} else if (item.CmvCarrier && String(item.CmvCarrier).trim() !== "") {
						this.formDebtorType = "CARRIER";
					} else {
						this.formDebtorType = null;
					}
				}
			},
			getDebtorType(item) {
				if (this.filter.DebtType === "CARRIER") return "CARRIER";
				if (this.filter.DebtType === "SUPPLIER") return "SUPPLIER";
				if (this.formDebtorType) return this.formDebtorType;
				if (item && item.CmvSupplier && String(item.CmvSupplier).trim() !== "") {
					return "SUPPLIER";
				}
				if (item && item.CmvCarrier && String(item.CmvCarrier).trim() !== "") {
					return "CARRIER";
				}
				return "SUPPLIER";
			},
			isCarrierDebtTarget(item) {
				return this.getDebtorType(item) === "CARRIER";
			},
			onDebtorTypeChange(val, item) {
				this.formDebtorType = val;
				if (val === "CARRIER") {
					if (item) {
						item.CmvSupplier = null;
						item.CmvSupplierName = null;
					}
				}
			},
			showFullObservation(item) {
				this.selectedObservationItem = item;
				this.observationDialog = true;
			},
			openPdf(item) {
				this.selectedMovementPdf = Object.assign({}, item);
				this.dialogPdf = true;
			},
			loadContainerMasterList() {
				_sContainerMasterService
					.list()
					.then((response) => {
						if (response.status === 200) {
							this.containerMasterList = response.data || [];
						}
					})
					.catch((error) => {
						console.error("Error al cargar maestro de envases en movimientos:", error);
					});
			},
			onSkuSelect(cmtID, item) {
				if (!cmtID) {
					item.CmvContainerType = "";
					item.CmvContainerColor = "";
					this.stockInfo = null;
					return;
				}
				const found = this.containerMasterList.find(x => x.CmtID === cmtID);
				if (found) {
					item.CmtID = found.CmtID;
					item.CmvContainerType = found.CmtContainerTypeID || "";
					item.CmvContainerColor = found.CmtColorID || "";
				}
				this.loadStock(item);
			},
			loadStock(item) {
				const cmtID = item && item.CmtID ? parseInt(item.CmtID, 10) : 0;
				const locationID = item && item.CinLocationID ? parseInt(item.CinLocationID, 10) : 0;
				if (!cmtID || !locationID) {
					this.stockInfo = null;
					return;
				}
				_sContainerInventoryService
					.getStock(cmtID, locationID, this.$fun.getUserID())
					.then((response) => {
						if (response.status === 200) {
							this.stockInfo = response.data || null;
						}
					})
					.catch((error) => {
						this.stockInfo = null;
						console.error("Error al consultar stock de inventario:", error);
					});
			},
			isMovementFullyReturned(item) {
				if (!item) return false;
				const owed = parseFloat(item.CmvQuantityOwed);
				return Boolean(item.CmvEntryDate && !isNaN(owed) && owed <= 0);
			},
			isMovementPartiallyReturned(item) {
				if (!item) return false;
				const owed = parseFloat(item.CmvQuantityOwed);
				const inQty = parseFloat(item.CmvQuantityIn) || 0;
				const defQty = parseFloat(item.CmvDefectiveQuantity) || 0;
				const lossQty = parseFloat(item.CmvLossQuantity) || 0;
				const totalReturned = inQty + defQty + lossQty;
				return totalReturned > 0 && owed > 0;
			},
			isMovementPending(item) {
				if (!item) return false;
				const owed = parseFloat(item.CmvQuantityOwed);
				if (!item.CmvEntryDate) return true;
				return !isNaN(owed) && owed > 0;
			},
			getTransitColor(item) {
				if (this.isMovementFullyReturned(item)) return "green darken-1";
				if (this.isMovementPartiallyReturned(item)) return "indigo darken-1";
				const days = item ? (item.CmvTransitDays || 0) : 0;
				if (days <= 2) return "blue darken-1";
				if (days <= 5) return "warning darken-1";
				return "red darken-1";
			},
			computeTransitDays(item) {
				if (!item || !item.CmvDepartureDate) return "0 días";
				const start = moment(item.CmvDepartureDate);
				if (!start.isValid()) return "0 días";
				const end = item.CmvEntryDate && moment(item.CmvEntryDate).isValid() ? moment(item.CmvEntryDate) : moment();
				const days = end.diff(start, "days");
				let status = "En Tránsito";
				if (this.isMovementFullyReturned(item)) {
					status = "Retornado";
				} else if (this.isMovementPartiallyReturned(item)) {
					status = "Retorno Parcial";
				}
				return `${days >= 0 ? days : 0} día(s) (${status})`;
			},
			calculateOwed(item) {
				const qtyOut = parseFloat(item.CmvQuantityOut) || 0;
				const qtyIn = parseFloat(item.CmvQuantityIn) || 0;
				const defective = parseFloat(item.CmvDefectiveQuantity) || 0;
				const loss = parseFloat(item.CmvLossQuantity) || 0;
				item.CmvQuantityOwed = Math.max(0, qtyOut - qtyIn - defective - loss);
			},
			onDepartureDateChange(dateString, item) {
				if (!dateString) return;
				const m = moment(dateString);
				if (m.isValid()) {
					item.CmvYear = m.year();
					item.CmvCampaign = m.year().toString();
					item.CmvMonth = m.month() + 1;
					item.CmvWeek = m.isoWeek();
				}
			},
			onVehicleSelect(vehicleObj, item) {
				if (vehicleObj && typeof vehicleObj === "object") {
					item.CmvLicensePlateID = vehicleObj.VehID || vehicleObj.id;
					item.ObjectCmvLicensePlate = vehicleObj;
					if (vehicleObj.VehPlate) {
						item.CmvLicensePlate = vehicleObj.VehPlate;
					}
					const carrier = vehicleObj.SpcCompanyName || vehicleObj.CarrierName || vehicleObj.CompanyName || vehicleObj.CompanyCarrierName || vehicleObj.Carrier;
					if (carrier) {
						item.CmvCarrier = carrier;
					}
					const driver = vehicleObj.DriverName || vehicleObj.Conductor || vehicleObj.Driver || vehicleObj.AdvDriverName;
					if (driver) {
						item.CmvDriver = driver;
					}
				}
			},
			onFarmSelect(farmVal, item) {
				if (farmVal && typeof farmVal === "object" && !Array.isArray(farmVal)) {
					item.CmvLocation = String(farmVal.FagID || farmVal.fagID || "");
					item.CmvLocationName = farmVal.FagName || farmVal.fagName || "";
				} else if (farmVal !== null && farmVal !== undefined && !Array.isArray(farmVal)) {
					item.CmvLocation = String(farmVal);
					if (this.farmsList && this.farmsList.length) {
						const found = this.farmsList.find((f) => String(f.FagID) === String(farmVal));
						if (found && found.FagName) {
							item.CmvLocationName = found.FagName;
						}
					}
				} else if (!farmVal) {
					item.CmvLocation = "";
					item.CmvLocationName = "";
				}
			},
			onForemanSelect(foremanVal, item) {
				if (foremanVal && typeof foremanVal === "object" && !Array.isArray(foremanVal)) {
					item.CmvForemanID = parseInt(foremanVal.NtpID || foremanVal.ntpID, 10) || null;
					item.CmvForeman = foremanVal.Foreman || foremanVal.foreman || "";
				} else if (foremanVal !== null && foremanVal !== undefined && !Array.isArray(foremanVal)) {
					item.CmvForemanID = parseInt(foremanVal, 10) || null;
					if (this.foremenList && this.foremenList.length) {
						const found = this.foremenList.find((f) => String(f.NtpID) === String(foremanVal));
						if (found && found.Foreman) {
							item.CmvForeman = found.Foreman;
						}
					}
				} else if (!foremanVal) {
					item.CmvForemanID = null;
					item.CmvForeman = "";
				}
			},
			getAvailableStockForStatus(item) {
				if (!this.stockInfo) return 0;
				const status = String(item?.CmvStatus || "");
				if (status === "2" || status.toLowerCase().includes("mal")) {
					return parseFloat(this.stockInfo.CinDefectiveStock) || 0;
				} else if (status === "3" || status.toLowerCase().includes("rot") || status.toLowerCase().includes("perd")) {
					return parseFloat(this.stockInfo.CinLostStock) || 0;
				}
				return parseFloat(this.stockInfo.CinCurrentStock) || 0;
			},
			ensureItemDetails(item) {
				if (!item) return false;
				if (!item.Details) {
					this.$set(item, "Details", []);
					this.initItemDetails(item);
				}
				return true;
			},
			async initItemDetails(item) {
				if (!item) return;
				if (item.Details && item.Details.length > 0) return;
				if (item.CmvID && parseInt(item.CmvID, 10) > 0) {
					try {
						const reqId = this.$fun.getUserID();
						const res = await _sContainerMovementService.getDetails(item.CmvID, reqId);
						if (res && res.data && Array.isArray(res.data) && res.data.length > 0) {
							this.$set(item, "Details", res.data.map(d => this.mapApiDetailToRow(d, item)));
							this.loadAllRowsStock(item);
							return;
						}
					} catch (e) {
						console.error("Error cargando detalles del movimiento:", e);
					}
				}
				if (item.CmtID) {
					this.$set(item, "Details", [this.createDetailFromMovement(item)]);
					this.loadAllRowsStock(item);
				} else {
					this.$set(item, "Details", [this.createEmptyDetailRow(item)]);
				}
			},
			createEmptyDetailRow(item) {
				return {
					CmdID: 0,
					CmtID: null,
					CmdContainerType: null,
					CmdContainerColor: null,
					CmdFruit: item?.CmvFruit || null,
					CmdStatus: null,
					CmdQuantityOut: "",
					CmdQuantityIn: 0,
					CmdDefectiveQuantity: 0,
					CmdLossQuantity: 0,
					CmdQuantityOwed: 0,
					CmdObservation: "",
					availableStock: null,
					stockLoaded: false
				};
			},
			createDetailFromMovement(item) {
				return {
					CmdID: 0,
					CmtID: item.CmtID,
					CmdContainerType: item.CmvContainerType,
					CmdContainerColor: item.CmvContainerColor,
					CmdFruit: item.CmvFruit,
					CmdStatus: item.CmvStatus,
					CmdQuantityOut: item.CmvQuantityOut,
					CmdQuantityIn: item.CmvQuantityIn || 0,
					CmdDefectiveQuantity: item.CmvDefectiveQuantity || 0,
					CmdLossQuantity: item.CmvLossQuantity || 0,
					CmdQuantityOwed: item.CmvQuantityOwed || item.CmvQuantityOut,
					CmdObservation: item.CmvObservation || "",
					availableStock: null,
					stockLoaded: false
				};
			},
			mapApiDetailToRow(d, item) {
				return {
					CmdID: d.CmdID || 0,
					CmtID: d.CmtID,
					CmdContainerType: d.CmdContainerType,
					CmdContainerColor: d.CmdContainerColor,
					CmdFruit: d.CmdFruit,
					CmdStatus: d.CmdStatus,
					CmdQuantityOut: d.CmdQuantityOut,
					CmdQuantityIn: d.CmdQuantityIn || 0,
					CmdDefectiveQuantity: d.CmdDefectiveQuantity || 0,
					CmdLossQuantity: d.CmdLossQuantity || 0,
					CmdQuantityOwed: d.CmdQuantityOwed,
					CmdObservation: d.CmdObservation || "",
					availableStock: null,
					stockLoaded: false
				};
			},
			addDetailRow(item) {
				if (!item.Details) {
					this.$set(item, "Details", []);
				}
				item.Details.push(this.createEmptyDetailRow(item));
			},
			removeDetailRow(item, index) {
				if (!item.Details || item.Details.length <= 1) return;
				item.Details.splice(index, 1);
				this.onRowQuantityChange(item);
			},
			onDetailSkuSelect(row, item) {
				if (!row.CmtID) return;
				const found = this.containerMasterList.find(x => x.CmtID === row.CmtID);
				if (found) {
					if (!row.CmdContainerType) row.CmdContainerType = found.CmtType || found.CmtContainerTypeID || "";
					if (!row.CmdContainerColor) row.CmdContainerColor = found.CmtColor || found.CmtColorID || "";
				}
				this.loadRowStock(row, item);
			},
			async loadRowStock(row, item) {
				if (!row.CmtID || !item.CinLocationID) {
					row.availableStock = null;
					row.stockLoaded = false;
					return;
				}
				try {
					const reqId = this.$fun.getUserID();
					const res = await _sContainerInventoryService.getStock(row.CmtID, item.CinLocationID, reqId);
					if (res && res.status === 200 && res.data) {
						row.stockInfo = res.data;
						row.availableStock = this.getRowStockForStatus(row);
						row.stockLoaded = true;
					}
				} catch (e) {
					console.error("Error al consultar stock de la fila:", e);
				}
			},
			getRowStockForStatus(row) {
				if (!row || !row.stockInfo) return null;
				const st = String(row.CmdStatus || "").trim().toUpperCase();
				if (st.includes("MAL") || st.includes("DEFECT") || st.includes("LAV") || st.includes("ROT") || st === "2") {
					return parseFloat(row.stockInfo.CinDefectiveStock) || 0;
				}
				return parseFloat(row.stockInfo.CinCurrentStock) || 0;
			},
			getRowStockColor(row) {
				if (row.availableStock === null) return "grey lighten-3 grey--text";
				const qtyOut = parseFloat(row.CmdQuantityOut) || 0;
				if (qtyOut > row.availableStock) return "error white--text";
				if (row.availableStock > 0) return "teal lighten-5 teal--text text--darken-3";
				return "grey lighten-3 grey--text";
			},
			isRowInsufficientStock(row) {
				if (row.availableStock === null) return false;
				const qtyOut = parseFloat(row.CmdQuantityOut) || 0;
				return qtyOut > row.availableStock;
			},
			hasAnyInsufficientStock(item) {
				if (!item || !item.Details) return false;
				return item.Details.some(r => this.isRowInsufficientStock(r));
			},
			onPlantChange(item) {
				this.loadAllRowsStock(item);
			},
			loadAllRowsStock(item) {
				if (!item || !item.Details) return;
				item.Details.forEach(row => this.loadRowStock(row, item));
			},
			onRowQuantityChange(item) {
				const totalOut = this.computeTotalQuantityOut(item);
				item.CmvQuantityOut = totalOut;
				item.CmvQuantityOwed = Math.max(0, totalOut - (parseFloat(item.CmvQuantityIn) || 0) - (parseFloat(item.CmvLossQuantity) || 0));
			},
			computeTotalQuantityOut(item) {
				if (!item || !item.Details || !item.Details.length) {
					return Number(item?.CmvQuantityOut) || 0;
				}
				return item.Details.reduce((acc, row) => acc + (parseFloat(row.CmdQuantityOut) || 0), 0);
			},
			computeTotalQuantityOwed(item) {
				const totalOut = this.computeTotalQuantityOut(item);
				const inQty = parseFloat(item?.CmvQuantityIn) || 0;
				const lossQty = parseFloat(item?.CmvLossQuantity) || 0;
				return Math.max(0, totalOut - inQty - lossQty);
			},
			async viewMovementDetails(item) {
				this.selectedMovementForDetails = item;
				this.movementDetailsForView = [];
				this.loadingMovementDetails = true;
				this.viewDetailsDialog = true;
				try {
					const reqId = this.$fun.getUserID();
					const res = await _sContainerMovementService.getDetails(item.CmvID, reqId);
					if (res && res.data && Array.isArray(res.data) && res.data.length > 0) {
						this.movementDetailsForView = res.data;
					} else {
						this.movementDetailsForView = [{
							CmdID: 0,
							CmtID: item.CmtID,
							CmtDescription: item.CmtDescription,
							CmdContainerColorName: item.CmvContainerColorName,
							CmdFruitName: item.CmvFruitName,
							CmdQuantityOut: item.CmvQuantityOut,
							CmdQuantityIn: item.CmvQuantityIn,
							CmdDefectiveQuantity: item.CmvDefectiveQuantity,
							CmdLossQuantity: item.CmvLossQuantity,
							CmdQuantityOwed: item.CmvQuantityOwed
						}];
					}
				} catch (e) {
					console.error("Error al cargar detalles del movimiento:", e);
				} finally {
					this.loadingMovementDetails = false;
				}
			},
			getRowProjectedOwed(row) {
				if (!row) return 0;
				const initialOwed = parseFloat(row.CmdQuantityOwed) || 0;
				const qIn = parseFloat(row.CmdQuantityIn) || 0;
				const qDef = parseFloat(row.CmdDefectiveQuantity) || 0;
				const qLoss = parseFloat(row.CmdLossQuantity) || 0;
				const rem = initialOwed - (qIn + qDef + qLoss);
				return rem >= 0 ? rem : 0;
			},
			isInsufficientStock(item) {
				return this.hasAnyInsufficientStock(item);
			},
			async openReturnModal(item) {
				this.returnItem = Object.assign({}, item);
				const owed = parseFloat(this.returnItem.CmvQuantityOwed);
				if (isNaN(owed) || owed === 0) {
					const qtyOut = parseFloat(this.returnItem.CmvQuantityOut) || 0;
					const qtyIn = parseFloat(this.returnItem.CmvQuantityIn) || 0;
					const qtyDef = parseFloat(this.returnItem.CmvDefectiveQuantity) || 0;
					const qtyLoss = parseFloat(this.returnItem.CmvLossQuantity) || 0;
					this.returnItem.CmvQuantityOwed = Math.max(0, qtyOut - qtyIn - qtyDef - qtyLoss);
				}

				this.deliveryForm = {
					CmvEntryDate: moment().format("YYYY-MM-DD"),
					ReturnLocationID: item.ReturnLocationID || item.CinLocationID,
					CmvReturnLicensePlate: item.CmvLicensePlate || item.CmvSecondaryLicensePlate || "",
					CmvReturnGuide: "",
					CmvQuantityIn: "",
					CmvDefectiveQuantity: "",
					CmvLossQuantity: "",
					CmvObservation: ""
				};
				this.returnDetailsList = [];
				this.loadingReturnDetails = true;
				this.returnDialog = true;

				try {
					const reqId = this.$fun.getUserID();
					const res = await _sContainerMovementService.getDetails(item.CmvID, reqId);
					if (res && res.data && Array.isArray(res.data) && res.data.length > 0) {
						this.returnDetailsList = res.data.map(d => ({
							...d,
							CmdQuantityIn: "",
							CmdDefectiveQuantity: "",
							CmdLossQuantity: "",
							returnObs: ""
						}));
					} else {
						this.returnDetailsList = [{
							CmdID: 0,
							CmtID: item.CmtID,
							CmtDescription: item.CmtDescription,
							CmdContainerColorName: item.CmvContainerColorName,
							CmdFruitName: item.CmvFruitName,
							CmdQuantityOut: item.CmvQuantityOut,
							CmdQuantityOwed: item.CmvQuantityOwed,
							CmdQuantityIn: "",
							CmdDefectiveQuantity: "",
							CmdLossQuantity: "",
							returnObs: ""
						}];
					}
				} catch (e) {
					console.error("Error cargando detalle para retorno:", e);
				} finally {
					this.loadingReturnDetails = false;
				}
			},
			onDeliveryQuantityInput() {
				// Reactividad controlada a través de computed properties
			},
			confirmReturn() {
				if (!this.deliveryForm.CmvEntryDate) {
					this.$fun.alert("Por favor seleccione la Fecha de Ingreso/Retorno", "warning");
					return;
				}
				if (!this.deliveryForm.ReturnLocationID) {
					this.$fun.alert("Por favor seleccione la Planta / Ubicación de Retorno", "warning");
					return;
				}
				if (!String(this.deliveryForm.CmvReturnLicensePlate || "").trim()) {
					this.$fun.alert("Por favor registre la Placa de Retorno", "warning");
					return;
				}
				if (this.returnPlateMismatch && !String(this.deliveryForm.CmvObservation || "").trim()) {
					this.$fun.alert("La Placa de Retorno no coincide con la placa de salida. Debe registrar el motivo en el campo Observación.", "warning");
					return;
				}

				const batchTotal = this.totalReturnBatch;
				if (batchTotal <= 0) {
					this.$fun.alert("Debe ingresar al menos una unidad mayor a 0 en Buen Estado, Mal Estado o Rotas en alguna de las líneas.", "warning");
					return;
				}

				for (let i = 0; i < this.returnDetailsList.length; i++) {
					const row = this.returnDetailsList[i];
					const rowIn = parseFloat(row.CmdQuantityIn) || 0;
					const rowDef = parseFloat(row.CmdDefectiveQuantity) || 0;
					const rowLoss = parseFloat(row.CmdLossQuantity) || 0;
					const rowOwed = parseFloat(row.CmdQuantityOwed) || 0;
					const rowTotal = rowIn + rowDef + rowLoss;
					if (rowTotal > rowOwed) {
						this.$fun.alert(`La cantidad total devuelta para '${row.CmtDescription || 'el SKU'}' (${rowTotal} u.) supera su saldo pendiente (${rowOwed} u.).`, "error");
						return;
					}
				}

				const payload = {
					CmvID: this.returnItem.CmvID,
					CmvEntryDate: this.deliveryForm.CmvEntryDate,
					CmvQuantityIn: this.totalReturnIn,
					CmvDefectiveQuantity: this.totalReturnDefective,
					CmvLossQuantity: this.totalReturnLoss,
					CmvObservation: this.deliveryForm.CmvObservation || "",
					ReturnLocationID: this.deliveryForm.ReturnLocationID || null,
					CmvReturnLicensePlate: String(this.deliveryForm.CmvReturnLicensePlate || "").trim(),
					CmvReturnGuide: String(this.deliveryForm.CmvReturnGuide || "").trim(),
					Details: this.returnDetailsList.map(d => ({
						CmdID: d.CmdID || 0,
						CmtID: d.CmtID,
						CmdQuantityIn: parseFloat(d.CmdQuantityIn) || 0,
						CmdDefectiveQuantity: parseFloat(d.CmdDefectiveQuantity) || 0,
						CmdLossQuantity: parseFloat(d.CmdLossQuantity) || 0,
						CmdObservation: d.returnObs || ""
					}))
				};

				_sContainerMovementService
					.registerReturn(payload, this.$fun.getUserID())
					.then((res) => {
						if (res.status === 200) {
							this.$fun.alert("Recepción registrada exitosamente. Stock en planta actualizado.", "success");
							this.returnDialog = false;
							if (this.$refs.gridContainerMovement) {
								this.$refs.gridContainerMovement.refresh();
							}
						}
					})
					.catch((err) => {
						console.error("Error al registrar retorno:", err);
						const msg = err && err.response && err.response.data ? err.response.data : "Ocurrió un error al guardar el retorno del vehículo.";
						this.$fun.alert(typeof msg === "string" ? msg : "Ocurrió un error al guardar el retorno del vehículo.", "error");
					});
			},
			clearFilters() {
				this.filter = {
					StartDate: null,
					EndDate: null,
					Supplier: null,
					LicensePlate: null,
					Carrier: null,
					CmtID: null,
					CinLocationID: null,
					DebtType: null
				};
				this.formDebtorType = null;
				const grid = this.$refs.gridContainerMovement;
				if (grid) {
					if (typeof grid.searchBtn === "function") {
						grid.searchBtn();
					} else if (typeof grid.refresh === "function") {
						grid.refresh();
					}
				}
			},
			async save(item) {
				if (!item.CmvDepartureDate) {
					this.$fun.alert("Por favor seleccione la Fecha de Salida", "warning");
					return;
				}

				if (!item.CmvLicensePlateID && !item.CmvLicensePlate) {
					this.$fun.alert("Por favor seleccione la Placa Principal del Vehículo", "warning");
					return;
				}

				if (!item.CinLocationID) {
					this.$fun.alert("Por favor seleccione la Planta / Ubicación de Origen", "warning");
					return;
				}

				if (!item.Details || !item.Details.length) {
					this.$fun.alert("Debe agregar al menos una línea de envases a despachar", "warning");
					return;
				}

				// Validar cada línea del detalle
				for (let i = 0; i < item.Details.length; i++) {
					const row = item.Details[i];
					if (!row.CmtID) {
						this.$fun.alert(`Por favor seleccione el Envase / SKU en la fila #${i + 1}`, "warning");
						return;
					}
					const rowQty = parseFloat(row.CmdQuantityOut) || 0;
					if (rowQty <= 0) {
						this.$fun.alert(`La cantidad a salir en la fila #${i + 1} debe ser mayor a 0`, "warning");
						return;
					}
					if (this.isRowInsufficientStock(row)) {
						this.$fun.alert(
							`Stock insuficiente en la fila #${i + 1}: Solo hay ${row.availableStock} unidades disponibles en planta en esa condición. No es posible despachar ${rowQty} unidades.`,
							"error"
						);
						return;
					}
				}

				item.CmvID = parseInt(item.CmvID, 10) || 0;
				if (item.CmvID > 0 && this.isMovementFullyReturned(item)) {
					this.$fun.alert("El movimiento ya fue retornado por completo y sus saldos de inventario fueron liquidados.", "warning");
					return;
				}

				// Totalización de cabecera
				const totalOut = this.computeTotalQuantityOut(item);
				item.CmvQuantityOut = totalOut;
				if (item.Details.length === 1) {
					item.CmtID = item.Details[0].CmtID;
					item.CmvContainerType = item.Details[0].CmdContainerType || "";
					item.CmvContainerColor = item.Details[0].CmdContainerColor || "";
					item.CmvFruit = item.Details[0].CmdFruit || "";
					item.CmvStatus = item.Details[0].CmdStatus || "";
				} else {
					item.CmtID = item.Details[0].CmtID;
					item.CmvContainerType = "VARIOS";
					item.CmvContainerColor = "VARIOS";
					item.CmvFruit = item.Details[0].CmdFruit || "";
					item.CmvStatus = item.Details[0].CmdStatus || "";
				}

				item.CmvQuantityIn = item.CmvQuantityIn || 0;
				item.CmvLossQuantity = item.CmvLossQuantity || 0;
				item.CmvQuantityOwed = Math.max(0, totalOut - (parseFloat(item.CmvQuantityIn) || 0) - (parseFloat(item.CmvLossQuantity) || 0));

				item.SecStatus = 1;
				item.UsrCreateID = this.$fun.getUserID();
				item.UsrUpdateID = this.$fun.getUserID();

				// Sanitización estricta de Placa
				if (item.CmvLicensePlateID && typeof item.CmvLicensePlateID === "object") {
					item.CmvLicensePlate = parseInt(item.CmvLicensePlateID.VehID || item.CmvLicensePlateID.id, 10) || null;
					item.CmvLicensePlateID = item.CmvLicensePlate;
				} else if (item.CmvLicensePlateID != null) {
					item.CmvLicensePlate = parseInt(item.CmvLicensePlateID, 10) || null;
				} else if (item.CmvLicensePlate != null && typeof item.CmvLicensePlate !== "object") {
					item.CmvLicensePlate = parseInt(item.CmvLicensePlate, 10) || null;
				} else {
					item.CmvLicensePlate = null;
				}

				// Validación y asignación según tipo de deudor (Transportista vs Proveedor)
				if (this.isCarrierDebtTarget(item)) {
					item.CmvSupplier = null;
					item.CmvSupplierName = null;
					if (!item.CmvCarrier || !String(item.CmvCarrier).trim()) {
						this.$fun.alert("Por favor seleccione la Empresa Transportista responsable de la custodia de los envases.", "warning");
						return;
					}
				} else {
					if (item.CmvSupplier && typeof item.CmvSupplier === "object") {
						item.CmvSupplier = item.CmvSupplier.SupID || item.CmvSupplier.SupName || "";
					} else if (item.CmvSupplier != null) {
						item.CmvSupplier = String(item.CmvSupplier).trim();
						if (item.CmvSupplier === "") item.CmvSupplier = null;
					}
					if (!item.CmvSupplier) {
						this.$fun.alert("Por favor seleccione el Proveedor responsable de la deuda de envases.", "warning");
						return;
					}
				}

				if (item.CmvSupervisor && typeof item.CmvSupervisor === "object") {
					item.CmvSupervisor = item.CmvSupervisor.WkrName || item.CmvSupervisor.wkrName || "";
				}

				// Sanitización estricta de Capataz
				if (item.CmvForemanID && typeof item.CmvForemanID === "object") {
					if (!item.CmvForeman) {
						item.CmvForeman = String(item.CmvForemanID.Foreman || item.CmvForemanID.foreman || "");
					}
					item.CmvForemanID = parseInt(item.CmvForemanID.NtpID || item.CmvForemanID.ntpID || item.CmvForemanID.id, 10) || null;
				} else if (item.CmvForemanID !== null && item.CmvForemanID !== undefined) {
					item.CmvForemanID = parseInt(item.CmvForemanID, 10) || null;
				} else {
					item.CmvForemanID = null;
				}

				if (item.CmvForeman && typeof item.CmvForeman === "object") {
					item.CmvForeman = String(item.CmvForeman.Foreman || item.CmvForeman.foreman || "");
				} else if (item.CmvForeman !== null && item.CmvForeman !== undefined) {
					item.CmvForeman = String(item.CmvForeman);
				} else {
					item.CmvForeman = "";
				}

				// Sanitización estricta de Zona / Fundo Cosecha: SIEMPRE debe viajar como string primitivo, NUNCA un objeto
				if (item.CmvLocation && typeof item.CmvLocation === "object") {
					if (!item.CmvLocationName) {
						item.CmvLocationName = String(item.CmvLocation.FagName || item.CmvLocation.fagName || "");
					}
					item.CmvLocation = String(item.CmvLocation.FagID || item.CmvLocation.fagID || item.CmvLocation.id || "");
				} else if (item.CmvLocation !== null && item.CmvLocation !== undefined) {
					item.CmvLocation = String(item.CmvLocation);
				} else {
					item.CmvLocation = "";
				}

				// Sanitización estricta de Tipo de Movimiento (DefID 1732: IQF, FRESCOS, MAQUILA)
				if (item.CmvType && typeof item.CmvType === "object") {
					item.CmvType = String(item.CmvType.DedValue || item.CmvType.DedID || item.CmvType.id || "");
				} else if (item.CmvType !== null && item.CmvType !== undefined) {
					item.CmvType = String(item.CmvType).trim();
				} else {
					item.CmvType = "";
				}

				// Adjuntar JSON de detalles multilínea
				item.Details = item.Details.map(d => ({
					CmdID: d.CmdID || 0,
					CmtID: d.CmtID,
					CmdContainerType: d.CmdContainerType || "",
					CmdContainerColor: d.CmdContainerColor || "",
					CmdFruit: d.CmdFruit || "",
					CmdStatus: d.CmdStatus || "",
					CmdQuantityOut: parseFloat(d.CmdQuantityOut) || 0,
					CmdQuantityIn: parseFloat(d.CmdQuantityIn) || 0,
					CmdDefectiveQuantity: parseFloat(d.CmdDefectiveQuantity) || 0,
					CmdLossQuantity: parseFloat(d.CmdLossQuantity) || 0,
					CmdQuantityOwed: Math.max(0, (parseFloat(d.CmdQuantityOut) || 0) - (parseFloat(d.CmdQuantityIn) || 0) - (parseFloat(d.CmdLossQuantity) || 0)),
					CmdObservation: d.CmdObservation || ""
				}));
				item.DetailsJson = JSON.stringify(item.Details);

				if (typeof item.save === "function") {
					item.save();
				}
			}
		}
	};
</script>

<style scoped lang="scss">
	/* ---------- Acentos por sección ---------- */
	.cm-tone-blue {
		--cm-accent: #1a5cff;
		--cm-accent-bg: #e9efff;
	}
	.cm-tone-teal {
		--cm-accent: #0f9d8a;
		--cm-accent-bg: #e1f5f1;
	}
	.cm-tone-violet {
		--cm-accent: #7a5cf0;
		--cm-accent-bg: #ede9fe;
	}
	.cm-tone-green {
		--cm-accent: #2e9e5b;
		--cm-accent-bg: #e5f6ec;
	}
	.cm-tone-amber {
		--cm-accent: #e08a00;
		--cm-accent-bg: #fdf2de;
	}

	/* ---------- Tarjetas ---------- */
	.cm-filter-card,
	.cm-section-card {
		background: #ffffff;
		border: 1px solid #e4eaf2;
		border-radius: 8px;
		box-shadow: 0 1px 2px rgba(16, 42, 67, 0.05), 0 1px 3px rgba(16, 42, 67, 0.06);
		transition: box-shadow 0.2s ease;

		::v-deep .v-label {
			color: #3f4d63;
			font-size: 11.5px;
			letter-spacing: 0.2px;
		}
	}

	.cm-section-card {
		border-left: 3px solid var(--cm-accent, #1a5cff);
	}

	.cm-filter-card:hover,
	.cm-section-card:hover {
		box-shadow: 0 4px 14px rgba(16, 42, 67, 0.1);
	}

	/* ---------- Encabezados ---------- */
	.cm-filter-header,
	.cm-section-header {
		display: flex;
		align-items: center;
		gap: 10px;
		padding: 10px 16px;
		background: #fafcfe;
		border-bottom: 1px solid #edf1f7;
		border-radius: 7px 7px 0 0;
	}

	.cm-filter-icon,
	.cm-section-icon {
		display: flex;
		align-items: center;
		justify-content: center;
		width: 30px;
		height: 30px;
		border-radius: 8px;
		background: var(--cm-accent-bg, #e9efff);
		flex-shrink: 0;
	}

	.cm-filter-title,
	.cm-section-title {
		font-size: 13px;
		font-weight: 600;
		color: #24344d;
		letter-spacing: 0.2px;
	}

	.cm-filter-subtitle,
	.cm-section-subtitle {
		font-size: 11px;
		color: #93a1b5;
		margin-top: 1px;
	}

	.cm-section-number {
		font-size: 11px;
		font-weight: 600;
		color: var(--cm-accent, #1a5cff);
		background: var(--cm-accent-bg, #e9efff);
		padding: 3px 9px;
		border-radius: 12px;
		letter-spacing: 0.6px;
	}

	/* ---------- Cuerpo de las tarjetas ---------- */
	.cm-filter-body {
		padding: 12px 6px 6px 6px;
	}

	.cm-section-body {
		padding: 10px 6px 12px 6px;
	}

	/* ---------- Campos calculados (solo lectura) ---------- */
	.cm-computed-field {
		::v-deep .v-input__slot {
			background: #f5f7fa;
			border-radius: 4px;
		}
		::v-deep fieldset {
			border-color: #e2e7ef !important;
		}
		::v-deep .v-label,
		::v-deep .v-input--is-focused .v-label {
			color: #71809a !important;
		}
	}

	/* ---------- Campo "Debe (Pendiente)" resaltado ---------- */
	.cm-owed-field {
		::v-deep .v-input__slot {
			background: #fdf6e3;
			border-radius: 4px;
		}
		::v-deep fieldset {
			border-color: #f0ddab !important;
		}
		::v-deep .v-label,
		::v-deep .v-input--is-focused .v-label {
			color: #8a6d00 !important;
			font-weight: 700 !important;
		}
		::v-deep input {
			font-weight: 700;
			color: #7a6200;
		}
	}

	.bg-light-indigo {
		background-color: #f5f3ff !important;
	}

	/* ---------- Selector de Deudor / Responsable de Envases ---------- */
	.cm-debtor-toggle {
		border: 1px solid #cbd5e1 !important;
		border-radius: 6px !important;
		overflow: hidden;
		background: #ffffff;
	}
	.cm-debtor-toggle .v-btn {
		text-transform: none !important;
		font-size: 11px !important;
		height: 26px !important;
		padding: 0 10px !important;
		letter-spacing: normal !important;
	}

	/* ---------- Grupos de Filtros Organizados ---------- */
	.cm-filter-group {
		background: #ffffff;
		border: 1px solid #e2e8f0;
		border-radius: 8px;
		padding: 10px 12px 6px 12px;
		height: 100%;
		transition: border-color 0.15s ease;
	}

	.cm-filter-group:hover {
		border-color: #cbd5e1;
	}

	.cm-group-label {
		display: flex;
		align-items: center;
		font-size: 11px;
		font-weight: 700;
		text-transform: uppercase;
		letter-spacing: 0.5px;
		color: #475569;
		margin-bottom: 8px;
		padding-bottom: 4px;
		border-bottom: 1px dashed #e2e8f0;
	}

	/* ---------- Altura Uniforme y Celdas de Tabla ---------- */
	::v-deep .v-data-table td {
		white-space: nowrap !important;
		height: 38px !important;
		padding: 0 10px !important;
		font-size: 12px !important;
	}

	::v-deep .v-data-table th {
		white-space: nowrap !important;
		height: 40px !important;
		font-size: 11.5px !important;
		font-weight: 700 !important;
		background: #f8fafc !important;
		color: #334155 !important;
	}

	/* ---------- Responsive ---------- */
	@media (max-width: 600px) {
		.cm-filter-header,
		.cm-section-header {
			flex-wrap: wrap;
			gap: 8px;
		}
	}
</style>
